var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchEngineerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 4267 4267",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 187.318,
    y: 671.28,
    width: 229.087,
    height: 727.752,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3850.19,
    y: 671.28,
    width: 229.087,
    height: 727.752,
    style: {
      fill: "#fff"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 466.351,
    width: 2135.05,
    height: 3333.96
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.98,2433.9l-186.98,-0l2142.09,-1967.55l116.61,0l2016.05,1967.08l-171.358,0.466l-8.085,1366.42c-69.057,-12.823 -140.216,-8.085 -210.219,-8.085l-1406.85,0l0,-210.218l654.911,-0l-0,-404.266c-0,-55.878 13.624,-132.809 -4.762,-185.954c-11.724,-33.902 -43.119,-57.705 -68.127,-81.581c-43.249,-41.308 -84.063,-84.742 -129.244,-123.988c-138.752,-120.536 -269.726,-252.028 -404.266,-377.302c-89.432,-83.27 -176.228,-169.331 -266.816,-251.3c-27.102,-24.522 -125.075,-113.792 -125.075,-113.792l-977.399,930.617l0.467,607.566l665.4,-0l0,218.303l-1636.35,-0.039l0,-1366.38Zm647.136,832.546l-0,315.623l105.224,0l0.192,-419.091l-105.416,103.468Zm-0,-542.135l1301.17,-1221.13l26.72,10.047l46.072,-484.542l73.655,-167.97l-144.359,140.561l-1303.19,1218.2l-0.073,504.835Zm-436.099,-121.021l-0.467,978.436l210.607,0.343l-0.741,-1180.92l-209.399,202.138Zm-210.798,-1932.47l1422.21,1.892l-217.403,209.983l-983.625,-1.18l-10.803,517.942l-210.096,0.015l-0.286,-728.652Zm3705.96,218.78c-215.983,0 -430.746,-8.085 -646.826,-8.085c-102.853,-0 -213.145,22.784 -315.327,6.888c-60.98,-9.484 -126.099,-94.436 -169.751,-135.558c-14.336,-13.519 -43.766,-32.915 -36.449,-56.411c9.266,-29.762 273.791,-145.21 297.521,-145.258l992.111,120.12c21.774,0 57.608,-6.241 75.978,8.312c14.061,11.142 12.621,32.269 12.921,48.294c0.816,43.086 0.04,86.262 0.04,129.357l-0,533.631l-210.218,-0l-0,-501.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M186.98,1608.72l0.926,351.938l209.897,-206.188c0,-0 0.111,-100.603 0.111,-144.701",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 739.945,
    cy: 1218.42,
    r: 128.778,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1878.65,
    cy: 2801.55,
    r: 128.778,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2133.33,
    cy: 2543.99,
    r: 128.778,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2129.18,
    cy: 3061.45,
    r: 128.778,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3526.72,
    cy: 1218.42,
    r: 128.778,
    style: {
      fill: "#fff"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2131.71,
    y: 2415.21,
    width: 126.356,
    height: 257.557
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2129.29,
    cy: 2543.99,
    r: 128.778,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 2388.02,
    cy: 2801.55,
    r: 128.778,
    style: {
      fill: "#fff"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2130.89,
    y: 2932.67,
    width: 127.178,
    height: 257.557
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2129.29,
    cy: 3061.45,
    r: 128.778,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2008.6,
    y: 2415.21,
    width: 126.356,
    height: 257.557
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2137.38,
    cy: 2543.99,
    r: 128.778,
    style: {
      fill: "#fff"
    }
  })), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2008.6,
    y: 2932.67,
    width: 127.178,
    height: 257.557
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2137.38,
    cy: 3061.45,
    r: 128.778,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2114.41,2430.97c-181.128,52.288 146.91,-42.408 -0,-0",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2131.62,
    y: 466.351,
    width: 2135.05,
    height: 3333.96
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4079.69,2433.9l186.981,-0l-2142.09,-1967.55l-2132.66,1967.08l171.358,0.466l8.085,1366.42c69.057,-12.823 140.216,-8.085 210.218,-8.085l1406.85,0l-0,-210.218l-654.911,-0l-0,-404.266c-0,-55.878 -13.624,-132.809 4.762,-185.954c11.724,-33.902 43.119,-57.705 68.127,-81.581c43.248,-41.308 84.063,-84.742 129.244,-123.988c138.752,-120.536 269.726,-252.028 404.266,-377.302c89.431,-83.27 176.227,-169.331 266.815,-251.3c27.102,-24.522 125.076,-113.792 125.076,-113.792l977.398,930.617l-0.466,607.566l-665.401,-0l0,218.303l1636.35,-0.039l0,-1366.38Zm-647.135,832.546l0,315.623l-105.224,0l-0.193,-419.091l105.417,103.468Zm0,-542.135l-1297.5,-1220.68l-69.149,64.756l28.277,-525.591l-180.561,-162.593l215.672,121.071l1303.19,1218.2l0.073,504.835Zm436.098,-121.021l0.467,978.436l-210.606,0.343l0.741,-1180.92l209.398,202.138Zm210.799,-1932.47l-1422.21,1.892l217.403,209.983l983.625,-1.18l10.803,517.942l210.096,0.015l0.286,-728.652Zm-3916.18,186.439c-0,-0 640.963,24.256 857.043,24.256c102.854,-0 213.146,22.784 315.328,6.888c60.979,-9.484 126.098,-94.436 169.751,-135.558c14.335,-13.519 43.766,-32.915 36.449,-56.411c-9.266,-29.762 -53.105,-25.089 -76.835,-25.138l-1212.8,0c-21.774,0 -57.608,-6.241 -75.978,8.312c-14.06,11.142 -12.621,32.269 -12.92,48.294c-0.816,43.086 -0.04,86.262 -0.04,129.357Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4079.38,1608.72l-0.926,351.938l-209.897,-206.188c-0,-0 -0.111,-100.603 -0.111,-144.701",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2160.35,2430.97c181.128,52.288 -146.91,-42.408 0,-0",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.414,
    y: 1608.72,
    width: 112.262,
    height: 145.346,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2129.18,
    y: 480.674,
    width: 10.558,
    height: 524.278,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2129.77,
    y: 1508.08,
    width: 10.558,
    height: 537.088,
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchEngineerLogo);
export default __webpack_public_path__ + "static/media/arch-engineer-logo.1ec294ba5037b7d33835a799239314de.svg";
export { ForwardRef as ReactComponent };